<div class="modal-header">
  <h2>{{ infoTitle }}</h2>
  <button style="margin-bottom: 10px;" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.close('Cross click')">
    <span aria-hidden="true">X</span>
  </button>
</div>
<div class="modal-body my-3">
  <p class="px-4">{{ infoMessage }}</p>
</div>
